import Vuex from 'vuex'

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    showModal: false,
  },
  mutations: {
    SET_STATE_KEY_TRUE(state, key) {
      state[key] = true;
    },
    SET_STATE_KEY_FALSE(state, key) {
      state[key] = false;
    },
    SET_STATE_KEY_VALUE(state, object) {
      Vue.set(state, object.key, object.value);
    },
  },
  actions: {
    openModal({commit}) {
      commit('SET_STATE_KEY_TRUE', 'showModal');
    },
    closeModal({commit}) {
      commit('SET_STATE_KEY_FALSE', 'showModal');
    },
  },
  getters: {
    relatedTypes() {
      return {
        option: 'Options',
        chargeur: 'Chargeur',
        dosseret: 'Dosserets',
        lock: 'Antivols',
        pare_brise: 'Pare brise',
        support: 'Support Top Case',
        support_smartphone: 'Support Smartphone',
        tablier: 'Tablier',
        top_case: 'Top cases',
      }
    },
  },
})

export default store
